import { render, staticRenderFns } from "./AddAdmins.vue?vue&type=template&id=78a21232&scoped=true"
import script from "./AddAdmins.vue?vue&type=script&lang=js"
export * from "./AddAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a21232",
  null
  
)

export default component.exports